module.exports = __webpack_public_path__ + "static/media/menu2.5a6db7a3.svg";